const verification = {
    disabledTitle: 'Design verification unavailable',
    disabled: 'Design verification is not enabled for this tenant. Please contact an administrator.',
    title: 'Design Verification Items',
    description: 'Manage design verification items and export Excel reports',
    units: 'units',
    items: 'items',
    modelName: 'Model Name',
    sessionTitle: 'Session Title',
    sessionDescription: 'Description',
    selectSession: 'Select a session to view',
    noUnits: 'No units yet',
    addUnit: 'Add Unit',
    editUnit: 'Edit Unit',
    deleteUnit: 'Delete Unit',
    addItem: 'Add Item',
    editItem: 'Edit Item',
    unitNumber: 'Unit Number',
    unitNameLabel: 'Unit Name',
    primary: 'Primary',
    secondary: 'Secondary',
    right: 'Right',
    reviewRequired: 'Required',
    reviewNotRequired: 'Not required',
    standardTargetHelp: 'Enter the standard/target value (most critical field)',
    classificationLabels: {
      performance: 'Performance',
      function: 'Function',
      reliability: 'Reliability/Durability',
      safety: 'Safety',
      cost: 'Cost',
      maintenance: 'Maintenance',
    },
    methodLabels: {
      unit_prototype: 'Unit Prototype',
      pre_test: 'Pre-test',
      design_calc: 'Design Calculation',
      competitor_comp: 'Competitor Comparison',
      analysis: 'Analysis',
      dr1: 'DR1',
      knowhow: 'Know-how',
      actual_confirm: 'Actual Confirmation',
    },
    sessionCreated: 'Session created',
    unitAdded: 'Unit added',
    itemAdded: 'Item added',
    delete: {
      sessionTitle: 'Delete verification session',
      sessionMessage:
        '"{{name}}" will be deleted, along with all {{unitCount}} units and {{itemCount}} verification items under it. This action cannot be undone.',
      unitTitle: 'Delete unit',
      unitMessage:
        '"{{name}}" will be deleted, along with all {{itemCount}} verification items under it. This action cannot be undone.',
      itemTitle: 'Delete verification item',
      itemMessage: 'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
    },
    chat: {
      title: 'AI Verification Chat',
      openTooltip: 'AI Verification Chat',
      closeTooltip: 'Close chat',
    },
    sessions: {
      title: 'Verification Sessions',
      noSessions: 'No verification sessions',
      create: 'Create New Session',
    },
    table: {
      unit: 'Unit',
      specification: 'Specification',
      itemName: 'Item',
      classification: 'Classification',
      standardTarget: 'Standard/Target',
      verificationMethod: 'Verification Method',
      review: 'Review',
      qualityRecordNo: 'Quality Record No.',
      qualityRecordTitle: 'Quality Record Title',
    },
    export: {
      dialogTitle: 'Export to Excel',
      excel: 'Export Excel',
      sessionLabel: 'Session',
      download: 'Download',
      exporting: 'Exporting...',
      error: 'Export failed',
    },
    drbfmLink: 'This item was generated from DRBFM analysis',
    drbfmLinkTooltip: 'View DRBFM analysis results',
    createSessionFailed: 'Failed to create session',
    saveItemFailed: 'Failed to save item',
    saveUnitFailed: 'Failed to save unit',
    deleteFailed: 'Failed to delete',
    sessionsLoadFailed: 'Failed to load sessions',
    sessionLoadFailed: 'Failed to load session',
  };

export default verification;
